window.DrinkLab = window.DrinkLab || {};

/**
 * SIMPS Drink Lab expansion recipes DL-035 to DL-071. Flipped to
 * testingStatus: 'approved' on 2026-08-11 at merchant request so the full
 * catalog is visible in normal (non-debug) preview for a SIMPS review
 * meeting. This is a preview-mode change on the dev theme only — MAIN has
 * not been touched and nothing here is public. If SIMPS wants any recipe
 * pulled after tasting, reset its testingStatus to 'untested' individually.
 * DL-041 and DL-043 use hero product keys (orange_soda, cherry) that do
 * not resolve against SHOPIFY_PRODUCTS and so stay invisible everywhere,
 * even now marked approved, until a real syrup product exists for them.
 */
window.DrinkLab.RECIPES_PART2 = [
  // ---------------- DIRTY SODA LAB (expansion pack, added 2026-08-11) ----------------
  // ⚠ DL-041 and DL-043 use hero product keys ('orange_soda', 'cherry') that do not
  // resolve against SHOPIFY_PRODUCTS — see engine hardFilter's PRODUCTS()[heroProductId]
  // check. They will not appear anywhere until a real
  // syrup product exists for them. Left in per "preserve all recipes" instruction.
  {
    id: 'DL-035', name: 'Watermelon Cream Dirty Soda',
    drinkCompatibility: { custom_soda: 3, creamy: 3 },
    heroProductId: 'watermelon',
    primaryProfiles: ['fruity', 'juicy', 'sweet'], secondaryProfiles: ['creamy', 'refreshing', 'candy'],
    adventure: 'experiment', familiarity: 2, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Watermelon', productId: 'watermelon' },
      { amount: '6 oz', ingredient: 'lemon-lime soda', productId: 'lemon_lime' },
      { amount: '1 oz', ingredient: 'cream or coconut cream' },
      { ingredient: 'ice' },
      { ingredient: 'fresh lime', optional: true }
    ],
    instructions: ['Fill glass with ice.', 'Add Watermelon syrup.', 'Pour in lemon-lime soda.', 'Slowly add cream.', 'Stir gently.'],
    dashUpgrade: { productId: 'coconut', amount: '1/4 oz', description: 'Add Coconut for a tropical watermelon cream finish.' },
    dashQuote: 'Watermelon got creamy. Nobody panic.',
    description: 'A dirty soda twist on watermelon, finished with a float of cream.',
    labPackId: 'dirty_soda_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-036', name: 'Blue Raspberry Dirty Soda',
    drinkCompatibility: { custom_soda: 3, creamy: 3 },
    heroProductId: 'blue_raspberry',
    primaryProfiles: ['candy', 'fruity', 'sweet'], secondaryProfiles: ['creamy', 'fun', 'refreshing'],
    adventure: 'experiment', familiarity: 2, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Blue Raspberry', productId: 'blue_raspberry' },
      { amount: '6 oz', ingredient: 'lemon-lime soda', productId: 'lemon_lime' },
      { amount: '1 oz', ingredient: 'cream or coconut cream' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add Blue Raspberry.', 'Top with lemon-lime soda.', 'Slowly add cream and stir.'],
    dashUpgrade: { productId: 'coconut', amount: '1/4 oz', description: 'Coconut turns this into full dirty-soda territory.' },
    dashQuote: "It's blue. It's creamy. Science has no further questions.",
    description: 'Classic blue raspberry soda, made dirty with a splash of cream.',
    labPackId: 'dirty_soda_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-037', name: 'Blue Raspberry Coconut Dirty Soda',
    drinkCompatibility: { custom_soda: 3, creamy: 3 },
    heroProductId: 'blue_raspberry',
    primaryProfiles: ['candy', 'tropical', 'sweet'], secondaryProfiles: ['creamy', 'fruity'],
    adventure: 'goose', familiarity: 3, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Blue Raspberry', productId: 'blue_raspberry' },
      { amount: '6 oz', ingredient: 'lemon-lime soda', productId: 'lemon_lime' },
      { amount: '1 oz', ingredient: 'cream or coconut cream' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add Blue Raspberry.', 'Add lemon-lime soda.', 'Finish with cream.', 'Stir gently.'],
    dashUpgrade: { productId: 'coconut', amount: '1/2 oz', description: 'Add Coconut for the full experiment.' },
    dashQuote: 'Blue Raspberry and Coconut. This is why supervision was revoked.',
    description: 'A wilder, coconut-forward take on the blue raspberry dirty soda.',
    labPackId: 'dirty_soda_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-038', name: 'Strawberries & Cream Dirty Soda',
    drinkCompatibility: { custom_soda: 3, creamy: 3 },
    heroProductId: 'strawberry',
    primaryProfiles: ['fruity', 'creamy', 'sweet'], secondaryProfiles: ['juicy', 'dessert'],
    adventure: 'classic', familiarity: 1, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Strawberry', productId: 'strawberry' },
      { amount: '6 oz', ingredient: 'lemon-lime soda', productId: 'lemon_lime' },
      { amount: '1 oz', ingredient: 'cream' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add Strawberry.', 'Top with lemon-lime soda.', 'Finish with cream and stir.'],
    dashUpgrade: { productId: 'vanilla', amount: '1/4 oz', description: 'Vanilla makes the strawberries-and-cream flavour even richer.' },
    dashQuote: 'Strawberries and cream learned carbonation.',
    description: 'A creamy, carbonated take on classic strawberries and cream.',
    labPackId: 'berry_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-039', name: 'Peaches & Cream Dirty Soda',
    drinkCompatibility: { custom_soda: 3, creamy: 3 },
    heroProductId: 'peach',
    primaryProfiles: ['fruity', 'creamy', 'sweet'], secondaryProfiles: ['juicy', 'refreshing'],
    adventure: 'classic', familiarity: 1, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Peach', productId: 'peach' },
      { amount: '6 oz', ingredient: 'lemon-lime soda', productId: 'lemon_lime' },
      { amount: '1 oz', ingredient: 'cream' },
      { ingredient: 'ice' }
    ],
    instructions: ['Build over ice.', 'Add Peach.', 'Top with soda.', 'Float cream and stir.'],
    dashUpgrade: { productId: 'vanilla', amount: '1/4 oz', description: 'Vanilla pushes it toward peaches-and-cream dessert territory.' },
    dashQuote: 'Peaches. Cream. Bubbles. My work here is done.',
    description: 'Juicy peach soda finished with a float of cream.',
    labPackId: 'dirty_soda_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-040', name: 'Raspberry Vanilla Dirty Soda',
    drinkCompatibility: { custom_soda: 3, creamy: 3 },
    heroProductId: 'raspberry',
    primaryProfiles: ['fruity', 'creamy', 'sweet'], secondaryProfiles: ['berry', 'dessert'],
    adventure: 'classic', familiarity: 1, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Raspberry', productId: 'raspberry' },
      { amount: '6 oz', ingredient: 'lemon-lime soda', productId: 'lemon_lime' },
      { amount: '1 oz', ingredient: 'cream' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add Raspberry.', 'Top with lemon-lime soda.', 'Finish with cream and stir.'],
    dashUpgrade: { productId: 'vanilla', amount: '1/4 oz', description: 'Add Vanilla for a raspberry-cream finish.' },
    dashQuote: 'Berry plus vanilla. Extremely responsible goose behaviour.',
    description: 'Raspberry dirty soda with a smooth vanilla-cream finish.',
    labPackId: 'berry_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-041', name: 'Orange Creamsicle Dirty Soda',
    drinkCompatibility: { custom_soda: 3, creamy: 3 },
    heroProductId: 'orange_soda',
    primaryProfiles: ['fruity', 'creamy', 'sweet'], secondaryProfiles: ['citrus', 'dessert'],
    adventure: 'classic', familiarity: 1, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '6 oz', ingredient: 'SIMPS/Local Orange Soda, prepared per retail directions', productId: 'orange_soda' },
      { amount: '1 oz', ingredient: 'cream' },
      { ingredient: 'ice' }
    ],
    instructions: ['Prepare Orange Soda per package directions.', 'Fill glass with ice.', 'Add prepared Orange Soda.', 'Float cream and stir.'],
    dashUpgrade: { productId: 'vanilla', amount: '1/4 oz', description: 'Vanilla turns the orange-and-cream combination into full creamsicle.' },
    dashQuote: 'I have successfully carbonated childhood.',
    description: 'A creamsicle-style dirty soda built on prepared Orange Soda.',
    labPackId: 'creamsicle_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-042', name: 'Coconut Lime Dirty Soda',
    drinkCompatibility: { custom_soda: 3, creamy: 3 },
    heroProductId: 'coconut',
    primaryProfiles: ['tropical', 'creamy', 'refreshing'], secondaryProfiles: ['bright', 'sweet'],
    adventure: 'experiment', familiarity: 2, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '3/4 oz', ingredient: 'SIMPS Coconut', productId: 'coconut' },
      { amount: '6 oz', ingredient: 'lemon-lime soda', productId: 'lemon_lime' },
      { amount: '1 oz', ingredient: 'cream or coconut cream' },
      { ingredient: 'fresh lime' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add Coconut syrup.', 'Top with lemon-lime soda.', 'Float cream, squeeze lime, and stir.'],
    dashQuote: 'Somewhere between dirty soda and tropical vacation.',
    description: 'Tropical coconut dirty soda brightened with fresh lime.',
    labPackId: 'tropical_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-043', name: 'Cherry Vanilla Dirty Cola',
    drinkCompatibility: { custom_soda: 3, creamy: 2 },
    heroProductId: 'cherry',
    primaryProfiles: ['fruity', 'sweet', 'classic'], secondaryProfiles: ['creamy', 'dessert'],
    adventure: 'classic', familiarity: 1, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '3/4 oz', ingredient: 'SIMPS Cherry', productId: 'cherry' },
      { ingredient: 'prepared cola', productId: 'cola' },
      { ingredient: 'splash of cream' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add Cherry syrup.', 'Top with prepared cola.', 'Add a splash of cream and stir.'],
    dashUpgrade: { productId: 'vanilla', amount: '1/4 oz', description: 'Vanilla makes it a full cherry-vanilla dirty cola.' },
    dashQuote: 'Cola received an unnecessary but highly successful upgrade.',
    description: 'A cherry-vanilla dirty cola built for classic-soda fans.',
    testingStatus: 'approved'
  },
  {
    id: 'DL-044', name: 'Tropical Dirty Soda',
    drinkCompatibility: { custom_soda: 3, creamy: 3 },
    heroProductId: 'passionfruit',
    primaryProfiles: ['tropical', 'creamy'], secondaryProfiles: ['fruity', 'bright', 'sweet'],
    adventure: 'experiment', familiarity: 3, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '3/4 oz', ingredient: 'SIMPS Passionfruit', productId: 'passionfruit' },
      { amount: '6 oz', ingredient: 'lemon-lime soda', productId: 'lemon_lime' },
      { amount: '1 oz', ingredient: 'coconut cream or cream' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add Passionfruit syrup.', 'Top with lemon-lime soda.', 'Float cream and stir.'],
    dashUpgrade: { productId: 'coconut', amount: '1/4 oz', description: 'Add Coconut to double down on tropical flavour.' },
    dashQuote: 'Passionfruit got dirty. Professionally speaking.',
    description: 'A tropical passionfruit dirty soda finished with cream.',
    labPackId: 'tropical_lab', testingStatus: 'approved'
  },

  // ---------------- LEMONADE EXPANSION (expansion pack, added 2026-08-11) ----------------
  {
    id: 'DL-045', name: 'Blue Raspberry Lemonade',
    drinkCompatibility: { lemonade: 3 },
    heroProductId: 'blue_raspberry',
    primaryProfiles: ['candy', 'fruity', 'tart'], secondaryProfiles: ['bright', 'refreshing'],
    adventure: 'classic', familiarity: 1, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Blue Raspberry', productId: 'blue_raspberry' },
      { amount: '7 oz', ingredient: 'prepared lemonade', productId: 'lemonade' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add Blue Raspberry syrup.', 'Top with lemonade and stir.'],
    dashUpgrade: { productId: 'watermelon', amount: '1/4 oz', description: 'Watermelon makes it even more unapologetically fun.' },
    dashQuote: 'Blue lemonade. Formal tasting notes have been cancelled.',
    description: 'A nostalgic, candy-bright blue raspberry lemonade.',
    labPackId: 'goose_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-046', name: 'Watermelon Lemonade',
    drinkCompatibility: { lemonade: 3 },
    heroProductId: 'watermelon',
    primaryProfiles: ['fruity', 'juicy', 'refreshing'], secondaryProfiles: ['sweet', 'tart'],
    adventure: 'classic', familiarity: 1, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Watermelon', productId: 'watermelon' },
      { amount: '7 oz', ingredient: 'prepared lemonade', productId: 'lemonade' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add Watermelon syrup.', 'Top with lemonade and stir.'],
    dashUpgrade: { productId: 'strawberry', amount: '1/4 oz', description: 'Strawberry adds a berry layer.' },
    dashQuote: 'Summer has entered the laboratory.',
    description: 'Juicy watermelon lemonade, built for peak summer.',
    testingStatus: 'approved'
  },
  {
    id: 'DL-047', name: 'Peach Lemonade',
    drinkCompatibility: { lemonade: 3 },
    heroProductId: 'peach',
    primaryProfiles: ['fruity', 'juicy'], secondaryProfiles: ['refreshing', 'bright'],
    adventure: 'classic', familiarity: 1, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Peach', productId: 'peach' },
      { amount: '7 oz', ingredient: 'prepared lemonade', productId: 'lemonade' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add Peach syrup.', 'Top with lemonade and stir.'],
    dashUpgrade: { productId: 'raspberry', amount: '1/4 oz', description: 'Raspberry adds a tart berry lift.' },
    dashQuote: 'Peach and lemon. Surprisingly little science required.',
    description: 'A juicy peach lemonade classic.',
    testingStatus: 'approved'
  },
  {
    id: 'DL-048', name: 'Strawberry Lemonade',
    drinkCompatibility: { lemonade: 3 },
    heroProductId: 'strawberry',
    primaryProfiles: ['fruity', 'juicy'], secondaryProfiles: ['tart', 'refreshing'],
    adventure: 'classic', familiarity: 1, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Strawberry', productId: 'strawberry' },
      { amount: '7 oz', ingredient: 'prepared lemonade', productId: 'lemonade' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add Strawberry syrup.', 'Top with lemonade and stir.'],
    dashUpgrade: { productId: 'raspberry', amount: '1/4 oz', description: 'Raspberry deepens the berry flavour.' },
    dashQuote: 'A classic for very good reasons.',
    description: 'The quintessential strawberry lemonade, made SIMPS-style.',
    testingStatus: 'approved'
  },
  {
    id: 'DL-049', name: 'Huckleberry Lemonade',
    drinkCompatibility: { lemonade: 3 },
    heroProductId: 'huckleberry',
    primaryProfiles: ['fruity', 'tart'], secondaryProfiles: ['berry', 'refreshing'],
    adventure: 'goose', familiarity: 4, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Huckleberry', productId: 'huckleberry' },
      { amount: '7 oz', ingredient: 'prepared lemonade', productId: 'lemonade' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add Huckleberry syrup.', 'Top with lemonade and stir.'],
    dashUpgrade: { productId: 'blackberry', amount: '1/4 oz', description: 'Blackberry adds an extra layer of dark berry.' },
    dashQuote: 'You said adventurous. I found a Huckleberry.',
    description: 'An adventurous, tart huckleberry lemonade for the curious.',
    testingStatus: 'approved'
  },

  // ---------------- ICED TEA EXPANSION (expansion pack, added 2026-08-11) ----------------
  {
    id: 'DL-050', name: 'Raspberry Iced Tea',
    drinkCompatibility: { iced_tea: 3 },
    heroProductId: 'raspberry',
    primaryProfiles: ['fruity', 'refreshing'], secondaryProfiles: ['berry', 'bright'],
    adventure: 'classic', familiarity: 1, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Raspberry', productId: 'raspberry' },
      { amount: '8 oz', ingredient: 'chilled black tea' },
      { ingredient: 'ice' },
      { ingredient: 'lemon', optional: true }
    ],
    instructions: ['Fill glass with ice.', 'Add Raspberry syrup.', 'Top with chilled black tea and stir.', 'Finish with lemon if using.'],
    dashUpgrade: { productId: 'peach', amount: '1/4 oz', description: 'Peach rounds out the berry with a soft, sweet note.' },
    dashQuote: 'Iced tea, now with considerably more personality.',
    description: 'Classic black iced tea brightened with raspberry.',
    testingStatus: 'approved'
  },
  {
    id: 'DL-051', name: 'Mango Iced Tea',
    drinkCompatibility: { iced_tea: 3 },
    heroProductId: 'mango',
    primaryProfiles: ['tropical', 'fruity'], secondaryProfiles: ['sweet', 'refreshing'],
    adventure: 'experiment', familiarity: 2, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Mango', productId: 'mango' },
      { amount: '8 oz', ingredient: 'chilled black or green tea' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add Mango syrup.', 'Top with chilled tea and stir.'],
    dashUpgrade: { productId: 'passionfruit', amount: '1/4 oz', description: 'Passionfruit adds a tart tropical edge.' },
    dashQuote: 'Tea went tropical. Management has been notified.',
    description: 'A tropical mango iced tea, bright and easy-drinking.',
    labPackId: 'tropical_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-052', name: 'Huckleberry Iced Tea',
    drinkCompatibility: { iced_tea: 3 },
    heroProductId: 'huckleberry',
    primaryProfiles: ['fruity', 'berry'], secondaryProfiles: ['tart', 'refreshing'],
    adventure: 'goose', familiarity: 4, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Huckleberry', productId: 'huckleberry' },
      { amount: '8 oz', ingredient: 'chilled black tea' },
      { ingredient: 'ice' },
      { ingredient: 'lemon' }
    ],
    instructions: ['Fill glass with ice.', 'Add Huckleberry syrup.', 'Top with chilled black tea.', 'Finish with lemon and stir.'],
    dashUpgrade: { productId: 'blackberry', amount: '1/4 oz', description: 'Blackberry deepens the dark berry flavour.' },
    dashQuote: 'Regular iced tea was getting far too comfortable.',
    description: 'A bold, tart huckleberry twist on iced tea.',
    testingStatus: 'approved'
  },

  // ---------------- MOJITO / MOCKTAIL EXPANSION (expansion pack, added 2026-08-11) ----------------
  // Base method for all mojito-style mocktails below: fresh lime + mint +
  // hero syrup + sparkling water over ice. None require SIMPS Mojito Mix.
  {
    id: 'DL-053', name: 'Watermelon Mojito',
    drinkCompatibility: { mocktail: 3 },
    heroProductId: 'watermelon',
    primaryProfiles: ['fruity', 'fresh', 'refreshing'], secondaryProfiles: ['juicy', 'bright'],
    adventure: 'experiment', familiarity: 2, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Watermelon', productId: 'watermelon' },
      { amount: '1 oz', ingredient: 'Local Mojito Mix', productId: 'mojito_mix' },
      { ingredient: 'sparkling water' },
      { ingredient: 'ice' },
      { ingredient: 'fresh mint and lime, to garnish', optional: true }
    ],
    instructions: ['Fill glass with ice.', 'Add Watermelon syrup and Local Mojito Mix.', 'Top with sparkling water and stir.', 'Garnish with fresh mint and lime.'],
    dashQuote: 'Watermelon plus mint. Extremely porch-compatible.',
    description: 'A refreshing watermelon mojito mocktail, mint and lime forward.',
    testingStatus: 'approved'
  },
  {
    id: 'DL-054', name: 'Blue Raspberry Mojito',
    drinkCompatibility: { mocktail: 3 },
    heroProductId: 'blue_raspberry',
    primaryProfiles: ['candy', 'fruity', 'fresh'], secondaryProfiles: ['bright', 'refreshing'],
    adventure: 'goose', familiarity: 3, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Blue Raspberry', productId: 'blue_raspberry' },
      { amount: '1 oz', ingredient: 'Local Mojito Mix', productId: 'mojito_mix' },
      { ingredient: 'sparkling water' },
      { ingredient: 'ice' },
      { ingredient: 'fresh mint and lime, to garnish', optional: true }
    ],
    instructions: ['Fill glass with ice.', 'Add Blue Raspberry syrup and Local Mojito Mix.', 'Top with sparkling water and stir.', 'Garnish with fresh mint and lime.'],
    dashQuote: 'The mojito establishment will have questions.',
    description: 'A candy-bright blue raspberry take on the classic mojito.',
    testingStatus: 'approved'
  },
  {
    id: 'DL-055', name: 'Strawberry Mojito',
    drinkCompatibility: { mocktail: 3 },
    heroProductId: 'strawberry',
    primaryProfiles: ['fruity', 'fresh'], secondaryProfiles: ['juicy', 'refreshing'],
    adventure: 'classic', familiarity: 1, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Strawberry', productId: 'strawberry' },
      { amount: '1 oz', ingredient: 'Local Mojito Mix', productId: 'mojito_mix' },
      { ingredient: 'sparkling water' },
      { ingredient: 'ice' },
      { ingredient: 'fresh mint and lime, to garnish', optional: true }
    ],
    instructions: ['Fill glass with ice.', 'Add Strawberry syrup and Local Mojito Mix.', 'Top with sparkling water and stir.', 'Garnish with fresh mint and lime.'],
    dashQuote: 'Strawberry and mint continue to pass peer review.',
    description: 'A classic strawberry mojito mocktail.',
    testingStatus: 'approved'
  },
  {
    id: 'DL-056', name: 'Prickly Pear Mojito',
    drinkCompatibility: { mocktail: 3 },
    heroProductId: 'prickly_pear',
    primaryProfiles: ['fruity', 'fresh', 'unusual'], secondaryProfiles: ['tart', 'bright'],
    adventure: 'goose', familiarity: 4, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Prickly Pear', productId: 'prickly_pear' },
      { amount: '1 oz', ingredient: 'Local Mojito Mix', productId: 'mojito_mix' },
      { ingredient: 'sparkling water' },
      { ingredient: 'ice' },
      { ingredient: 'fresh mint and lime, to garnish', optional: true }
    ],
    instructions: ['Fill glass with ice.', 'Add Prickly Pear syrup and Local Mojito Mix.', 'Top with sparkling water and stir.', 'Garnish with fresh mint and lime.'],
    dashQuote: 'The goose has selected Prickly Pear. Proceed.',
    description: 'An unusual, tart prickly pear mojito for the adventurous.',
    testingStatus: 'approved'
  },
  {
    id: 'DL-057', name: 'Mango Mojito',
    drinkCompatibility: { mocktail: 3 },
    heroProductId: 'mango',
    primaryProfiles: ['tropical', 'fruity', 'fresh'], secondaryProfiles: ['sweet', 'refreshing'],
    adventure: 'experiment', familiarity: 2, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Mango', productId: 'mango' },
      { amount: '1 oz', ingredient: 'Local Mojito Mix', productId: 'mojito_mix' },
      { ingredient: 'sparkling water' },
      { ingredient: 'ice' },
      { ingredient: 'fresh mint and lime, to garnish', optional: true }
    ],
    instructions: ['Fill glass with ice.', 'Add Mango syrup and Local Mojito Mix.', 'Top with sparkling water and stir.', 'Garnish with fresh mint and lime.'],
    dashQuote: 'Mint went somewhere tropical.',
    description: 'A tropical mango mojito mocktail.',
    testingStatus: 'approved'
  },
  {
    id: 'DL-058', name: 'Pineapple Mojito',
    drinkCompatibility: { mocktail: 3 },
    heroProductId: 'pineapple',
    primaryProfiles: ['tropical', 'fresh'], secondaryProfiles: ['fruity', 'bright'],
    adventure: 'experiment', familiarity: 2, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Pineapple', productId: 'pineapple' },
      { amount: '1 oz', ingredient: 'Local Mojito Mix', productId: 'mojito_mix' },
      { ingredient: 'sparkling water' },
      { ingredient: 'ice' },
      { ingredient: 'fresh mint and lime, to garnish', optional: true }
    ],
    instructions: ['Fill glass with ice.', 'Add Pineapple syrup and Local Mojito Mix.', 'Top with sparkling water and stir.', 'Garnish with fresh mint and lime.'],
    dashQuote: 'Pineapple has joined the mint department.',
    description: 'A bright, tropical pineapple mojito mocktail.',
    testingStatus: 'approved'
  },
  {
    id: 'DL-059', name: 'Blackberry Mojito',
    drinkCompatibility: { mocktail: 3 },
    heroProductId: 'blackberry',
    primaryProfiles: ['fruity', 'fresh'], secondaryProfiles: ['berry', 'tart'],
    adventure: 'experiment', familiarity: 2, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Blackberry', productId: 'blackberry' },
      { amount: '1 oz', ingredient: 'Local Mojito Mix', productId: 'mojito_mix' },
      { ingredient: 'sparkling water' },
      { ingredient: 'ice' },
      { ingredient: 'fresh mint and lime, to garnish', optional: true }
    ],
    instructions: ['Fill glass with ice.', 'Add Blackberry syrup and Local Mojito Mix.', 'Top with sparkling water and stir.', 'Garnish with fresh mint and lime.'],
    dashQuote: 'Dark berries. Fresh mint. Goose-approved.',
    description: 'A dark-berry mojito mocktail with fresh mint.',
    testingStatus: 'approved'
  },

  // ---------------- MOJITO / MOCKTAIL EXPANSION, cont'd (added 2026-08-11) ----------------
  {
    id: 'DL-060', name: 'Raspberry Mojito',
    drinkCompatibility: { mocktail: 3 },
    heroProductId: 'raspberry',
    primaryProfiles: ['fruity', 'fresh'], secondaryProfiles: ['berry', 'refreshing'],
    adventure: 'classic', familiarity: 1, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Raspberry', productId: 'raspberry' },
      { amount: '1 oz', ingredient: 'Local Mojito Mix', productId: 'mojito_mix' },
      { ingredient: 'sparkling water' },
      { ingredient: 'ice' },
      { ingredient: 'fresh mint and lime, to garnish', optional: true }
    ],
    instructions: ['Fill glass with ice.', 'Add Raspberry syrup and Local Mojito Mix.', 'Top with sparkling water and stir.', 'Garnish with fresh mint and lime.'],
    dashUpgrade: { productId: 'blackberry', amount: '1/4 oz', description: 'Blackberry deepens the berry flavour.' },
    dashQuote: 'Berry, mint, bubbles. A mojito with excellent references.',
    description: 'A classic raspberry mojito mocktail.',
    labPackId: 'berry_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-061', name: 'Watermelon Lime Cooler',
    drinkCompatibility: { mocktail: 3 },
    heroProductId: 'watermelon',
    primaryProfiles: ['fruity', 'fresh', 'refreshing'], secondaryProfiles: ['juicy', 'bright'],
    adventure: 'classic', familiarity: 1, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Watermelon', productId: 'watermelon' },
      { amount: '1/2 oz', ingredient: 'SIMPS Margarita Mix (or fresh lime juice)', productId: 'margarita_mix' },
      { ingredient: 'sparkling water' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add Watermelon syrup and Margarita Mix (or lime juice).', 'Top with sparkling water and stir.'],
    dashUpgrade: { productId: 'prickly_pear', amount: '1/4 oz', description: 'Prickly Pear adds a desert-fruit twist.' },
    dashQuote: 'Simple, cold, correct.',
    description: 'A no-fuss watermelon lime cooler.',
    labPackId: 'bright_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-062', name: 'Blue Raspberry Limeade',
    drinkCompatibility: { mocktail: 3 },
    heroProductId: 'blue_raspberry',
    primaryProfiles: ['candy', 'fruity', 'fresh'], secondaryProfiles: ['bright', 'refreshing'],
    adventure: 'experiment', familiarity: 2, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Blue Raspberry', productId: 'blue_raspberry' },
      { amount: '3/4 oz', ingredient: 'SIMPS Margarita Mix (or fresh lime juice)', productId: 'margarita_mix' },
      { ingredient: 'sparkling water' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add Blue Raspberry syrup and Margarita Mix (or lime juice).', 'Top with sparkling water and stir.'],
    dashUpgrade: { productId: 'watermelon', amount: '1/4 oz', description: 'Watermelon rounds out the candy edge.' },
    dashQuote: 'Extremely blue. Extremely limeade.',
    description: 'A candy-bright blue raspberry limeade.',
    labPackId: 'goose_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-063', name: 'Pomegranate Ginger Mule',
    drinkCompatibility: { mocktail: 3 },
    heroProductId: 'pomegranate',
    primaryProfiles: ['fruity', 'spiced'], secondaryProfiles: ['tart', 'bright'],
    adventure: 'experiment', familiarity: 2, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '3/4 oz', ingredient: 'SIMPS Pomegranate', productId: 'pomegranate' },
      { amount: '1/2 oz', ingredient: 'SIMPS Margarita Mix (or fresh lime juice)', productId: 'margarita_mix' },
      { amount: '1 oz', ingredient: 'Local Ginger Beer', productId: 'ginger_beer' },
      { amount: '4-5 oz', ingredient: 'soda water' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill copper mug or glass with ice.', 'Add Pomegranate syrup and Margarita Mix (or lime juice).', 'Add Local Ginger Beer and top with soda water.', 'Stir.'],
    dashUpgrade: { productId: 'hibiscus', amount: '1/4 oz', description: 'Hibiscus deepens the tart, floral edge.' },
    dashQuote: 'A grenadine shortcut, now with ginger.',
    description: 'A tart, ginger-spiked pomegranate mule mocktail.',
    labPackId: 'bright_lab', testingStatus: 'approved'
  },

  // ---------------- COCKTAIL EXPANSION (added 2026-08-11) ----------------
  // Alcohol recommendations gated behind age/legal handling per store policy — see spec §21.
  {
    id: 'DL-064', name: 'Watermelon Margarita',
    drinkCompatibility: { cocktail: 3 },
    heroProductId: 'watermelon',
    primaryProfiles: ['fruity', 'refreshing'], secondaryProfiles: ['tart', 'bright'],
    adventure: 'classic', familiarity: 1, serve: ['cold'],
    spirits: ['tequila'],
    intentTags: [],
    ingredients: [
      { amount: '1.5 oz', ingredient: 'tequila' },
      { amount: '3/4 oz', ingredient: 'SIMPS Watermelon', productId: 'watermelon' },
      { amount: '3/4 oz', ingredient: 'SIMPS Margarita Mix (or fresh lime juice)', productId: 'margarita_mix' },
      { ingredient: 'ice' }
    ],
    instructions: ['Shake tequila, syrup, and lime with ice.', 'Strain over fresh ice.', 'Garnish with lime.'],
    dashQuote: 'Peak summer, now with tequila.',
    description: 'A juicy watermelon margarita.',
    labPackId: 'bright_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-065', name: 'Blue Raspberry Margarita',
    drinkCompatibility: { cocktail: 3 },
    heroProductId: 'blue_raspberry',
    primaryProfiles: ['candy', 'fruity'], secondaryProfiles: ['tart', 'bold'],
    adventure: 'goose', familiarity: 3, serve: ['cold'],
    spirits: ['tequila'],
    intentTags: [],
    ingredients: [
      { amount: '1.5 oz', ingredient: 'tequila' },
      { amount: '3/4 oz', ingredient: 'SIMPS Blue Raspberry', productId: 'blue_raspberry' },
      { amount: '3/4 oz', ingredient: 'SIMPS Margarita Mix (or fresh lime juice)', productId: 'margarita_mix' },
      { ingredient: 'ice' }
    ],
    instructions: ['Shake tequila, syrup, and lime with ice.', 'Strain over fresh ice.', 'Garnish with lime.'],
    dashQuote: 'The margarita establishment will also have questions.',
    description: 'A bold, candy-bright blue raspberry margarita.',
    labPackId: 'goose_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-066', name: 'Passionfruit Margarita',
    drinkCompatibility: { cocktail: 3 },
    heroProductId: 'passionfruit',
    primaryProfiles: ['tropical', 'tart'], secondaryProfiles: ['fruity', 'bright'],
    adventure: 'experiment', familiarity: 2, serve: ['cold'],
    spirits: ['tequila'],
    intentTags: [],
    ingredients: [
      { amount: '1.5 oz', ingredient: 'tequila' },
      { amount: '3/4 oz', ingredient: 'SIMPS Passionfruit', productId: 'passionfruit' },
      { amount: '3/4 oz', ingredient: 'SIMPS Margarita Mix (or fresh lime juice)', productId: 'margarita_mix' },
      { ingredient: 'ice' }
    ],
    instructions: ['Shake tequila, syrup, and lime with ice.', 'Strain over fresh ice.', 'Garnish with lime.'],
    dashUpgrade: { productId: 'guava', amount: '1/4 oz', description: 'Guava rounds it out with a sweeter tropical finish.' },
    dashQuote: 'Tropical, tart, and now bar-cart ready.',
    description: 'A tart, tropical passionfruit margarita.',
    labPackId: 'tropical_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-067', name: 'Mango Margarita',
    drinkCompatibility: { cocktail: 3 },
    heroProductId: 'mango',
    primaryProfiles: ['tropical', 'fruity'], secondaryProfiles: ['sweet', 'refreshing'],
    adventure: 'classic', familiarity: 1, serve: ['cold'],
    spirits: ['tequila'],
    intentTags: [],
    ingredients: [
      { amount: '1.5 oz', ingredient: 'tequila' },
      { amount: '3/4 oz', ingredient: 'SIMPS Mango', productId: 'mango' },
      { amount: '3/4 oz', ingredient: 'SIMPS Margarita Mix (or fresh lime juice)', productId: 'margarita_mix' },
      { ingredient: 'ice' }
    ],
    instructions: ['Shake tequila, syrup, and lime with ice.', 'Strain over fresh ice.', 'Garnish with lime.'],
    dashUpgrade: { productId: 'passionfruit', amount: '1/4 oz', description: 'Passionfruit adds a tart tropical edge.' },
    dashQuote: 'A classic margarita, mango division.',
    description: 'A sweet, tropical mango margarita.',
    labPackId: 'tropical_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-068', name: 'Pineapple Rum Punch',
    drinkCompatibility: { cocktail: 3 },
    heroProductId: 'pineapple',
    primaryProfiles: ['tropical', 'fruity'], secondaryProfiles: ['sweet', 'refreshing'],
    adventure: 'classic', familiarity: 1, serve: ['cold'],
    spirits: ['rum'],
    intentTags: [],
    ingredients: [
      { amount: '1.5 oz', ingredient: 'rum' },
      { amount: '1 oz', ingredient: 'SIMPS Pineapple', productId: 'pineapple' },
      { amount: '1/2 oz', ingredient: 'SIMPS Margarita Mix (or fresh lime juice)', productId: 'margarita_mix' },
      { ingredient: 'sparkling water' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add rum and Pineapple syrup.', 'Add Margarita Mix (or lime juice).', 'Top with sparkling water and stir.'],
    dashUpgrade: { productId: 'guava', amount: '1/4 oz', description: 'Guava adds extra tropical depth.' },
    dashQuote: 'Rum punch, tropical division.',
    description: 'A tropical pineapple rum punch.',
    labPackId: 'tropical_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-069', name: 'Guava Rum Punch',
    drinkCompatibility: { cocktail: 3 },
    heroProductId: 'guava',
    primaryProfiles: ['tropical', 'fruity'], secondaryProfiles: ['sweet', 'bright'],
    adventure: 'experiment', familiarity: 2, serve: ['cold'],
    spirits: ['rum'],
    intentTags: [],
    ingredients: [
      { amount: '1.5 oz', ingredient: 'rum' },
      { amount: '1 oz', ingredient: 'SIMPS Guava', productId: 'guava' },
      { amount: '1/2 oz', ingredient: 'SIMPS Margarita Mix (or fresh lime juice)', productId: 'margarita_mix' },
      { ingredient: 'sparkling water' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add rum and Guava syrup.', 'Add Margarita Mix (or lime juice).', 'Top with sparkling water and stir.'],
    dashUpgrade: { productId: 'passionfruit', amount: '1/4 oz', description: 'Passionfruit adds a tart tropical edge.' },
    dashQuote: 'Tropical thunder, now with rum.',
    description: 'A bright, tropical guava rum punch.',
    labPackId: 'tropical_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-070', name: 'Raspberry Mule',
    drinkCompatibility: { cocktail: 3 },
    heroProductId: 'raspberry',
    primaryProfiles: ['fruity', 'bold'], secondaryProfiles: ['tart', 'berry'],
    adventure: 'classic', familiarity: 1, serve: ['cold'],
    spirits: ['vodka'],
    intentTags: [],
    ingredients: [
      { amount: '1.5 oz', ingredient: 'vodka' },
      { amount: '3/4 oz', ingredient: 'SIMPS Raspberry', productId: 'raspberry' },
      { amount: '1/2 oz', ingredient: 'SIMPS Margarita Mix (or fresh lime juice)', productId: 'margarita_mix' },
      { amount: '1 oz', ingredient: 'Local Ginger Beer', productId: 'ginger_beer' },
      { amount: '4-5 oz', ingredient: 'soda water' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill mug or glass with ice.', 'Add vodka and Raspberry syrup.', 'Add Margarita Mix (or lime juice) and Local Ginger Beer.', 'Top with soda water and stir.'],
    dashQuote: 'Berry, ginger, vodka. Textbook mule behaviour.',
    description: 'A classic raspberry twist on the vodka mule.',
    labPackId: 'berry_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-071', name: 'Pomegranate Mule',
    drinkCompatibility: { cocktail: 3 },
    heroProductId: 'pomegranate',
    primaryProfiles: ['fruity', 'bold'], secondaryProfiles: ['tart', 'bright'],
    adventure: 'experiment', familiarity: 2, serve: ['cold'],
    spirits: ['vodka'],
    intentTags: [],
    ingredients: [
      { amount: '1.5 oz', ingredient: 'vodka' },
      { amount: '3/4 oz', ingredient: 'SIMPS Pomegranate', productId: 'pomegranate' },
      { amount: '1/2 oz', ingredient: 'SIMPS Margarita Mix (or fresh lime juice)', productId: 'margarita_mix' },
      { amount: '1 oz', ingredient: 'Local Ginger Beer', productId: 'ginger_beer' },
      { amount: '4-5 oz', ingredient: 'soda water' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill mug or glass with ice.', 'Add vodka and Pomegranate syrup.', 'Add Margarita Mix (or lime juice) and Local Ginger Beer.', 'Top with soda water and stir.'],
    dashUpgrade: { productId: 'hibiscus', amount: '1/4 oz', description: 'Hibiscus deepens the tart, floral edge.' },
    dashQuote: 'A grenadine shortcut, now with vodka and ginger.',
    description: 'A tart, bold pomegranate vodka mule.',
    labPackId: 'bright_lab', testingStatus: 'approved'
  },
  // ---------------- ORANGE CREAM (added 2026-08-13) ----------------
  {
    id: 'DL-072', name: 'Orange Cream Soda',
    drinkCompatibility: { custom_soda: 3 },
    heroProductId: 'orange_soda',
    primaryProfiles: ['citrus', 'creamy'], secondaryProfiles: ['sweet', 'fun'],
    adventure: 'classic', familiarity: 1, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { ingredient: 'LOCAL Orange Soda, prepared to standard dilution', productId: 'orange_soda' },
      { amount: '8 oz', ingredient: 'chilled sparkling water' },
      { amount: '1/4 oz', ingredient: 'SIMPS Vanilla', productId: 'vanilla' },
      { ingredient: 'ice' },
      { ingredient: 'orange slice', optional: true }
    ],
    instructions: ['Fill a tall glass with ice.', 'Prepare the Orange Soda with chilled sparkling water to the standard LOCAL Orange Soda ratio.', 'Add SIMPS Vanilla.', 'Stir gently.', 'Garnish with an orange slice if desired.'],
    dashQuote: 'Orange soda plus vanilla. Turns out nostalgia is a measurable compound.',
    description: 'A nostalgic orange cream soda built on LOCAL Orange Soda and a touch of SIMPS Vanilla.',
    labPackId: 'creamsicle_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-073', name: 'Orange Cream Dirty Soda',
    drinkCompatibility: { custom_soda: 3, creamy: 3 },
    heroProductId: 'orange_soda',
    primaryProfiles: ['creamy', 'dessert'], secondaryProfiles: ['citrus', 'sweet'],
    adventure: 'experiment', familiarity: 2, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { ingredient: 'LOCAL Orange Soda, prepared to standard dilution', productId: 'orange_soda' },
      { amount: '6-8 oz', ingredient: 'chilled sparkling water' },
      { amount: '1/4 oz', ingredient: 'SIMPS Vanilla', productId: 'vanilla' },
      { amount: '3/4-1 oz', ingredient: 'half-and-half or heavy cream' },
      { ingredient: 'ice' },
      { ingredient: 'orange slice', optional: true }
    ],
    instructions: ['Fill a tall glass with ice.', 'Prepare the Orange Soda over the ice to the standard LOCAL Orange Soda ratio.', 'Stir in SIMPS Vanilla.', 'Slowly pour the cream over the top.', 'Stir gently for the orange-creamsicle effect.', 'Garnish with an orange slice if desired.'],
    dashQuote: 'I added cream to the experiment. Nobody stopped me.',
    description: 'An orange-creamsicle dirty soda: LOCAL Orange Soda, SIMPS Vanilla, and a float of cream.',
    labPackId: 'creamsicle_lab', testingStatus: 'approved'
  },
  // ---------------- FALL DRINK MENU (official SIMPS import, added 2026-08-13) ----------------
  {
    id: 'DL-074', name: 'Toasted Marshmallow Maple Latte',
    drinkCompatibility: { coffee: 3 },
    heroProductId: 'toasted_marshmallow',
    primaryProfiles: ['sweet', 'creamy'], secondaryProfiles: ['cozy', 'dessert'],
    adventure: 'classic', familiarity: 1, serve: ['hot'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Toasted Marshmallow', productId: 'toasted_marshmallow' },
      { amount: '1/2 oz', ingredient: 'real maple syrup' },
      { amount: '2 shots', ingredient: 'espresso' },
      { amount: '8-10 oz', ingredient: 'steamed milk' },
      { ingredient: 'cinnamon or toasted marshmallow, to garnish', optional: true }
    ],
    instructions: ['Stir Toasted Marshmallow and maple syrup into the espresso.', 'Add steamed milk.', 'Optionally garnish with cinnamon or toasted marshmallow.'],
    dashQuote: 'A campfire, minus the risk of setting the lab on fire.',
    description: 'A cozy toasted-marshmallow latte with a maple finish.',
    labPackId: 'fall_lab', collection: 'fall_drink_menu', recipeSource: 'simps', testingStatus: 'approved'
  },
  {
    id: 'DL-075', name: 'Salted Maple Cold Brew',
    drinkCompatibility: { coffee: 3 },
    heroProductId: 'salted_caramel',
    primaryProfiles: ['sweet', 'bold'], secondaryProfiles: ['creamy', 'dessert'],
    adventure: 'classic', familiarity: 1, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Salted Caramel', productId: 'salted_caramel' },
      { amount: '1/2 oz', ingredient: 'real maple syrup' },
      { amount: '8 oz', ingredient: 'cold brew' },
      { amount: '3 oz', ingredient: 'cream or milk' },
      { ingredient: 'ice' }
    ],
    instructions: ['Stir maple syrup into the cold brew.', 'Pour over ice.', 'Froth the cream or milk with SIMPS Salted Caramel.', 'Pour the salted caramel cold foam over the drink.'],
    dashQuote: 'Cold brew with a maple upgrade. Autumn in a cup.',
    description: 'Smooth cold brew topped with salted caramel maple cold foam.',
    labPackId: 'fall_lab', collection: 'fall_drink_menu', recipeSource: 'simps', testingStatus: 'approved'
  },
  {
    id: 'DL-076', name: 'Brown Sugar Chai',
    drinkCompatibility: { coffee: 3 },
    heroProductId: 'brown_sugar_cinnamon',
    primaryProfiles: ['spiced', 'cozy'], secondaryProfiles: ['warm', 'sweet'],
    adventure: 'classic', familiarity: 1, serve: ['hot'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Brown Sugar Cinnamon', productId: 'brown_sugar_cinnamon' },
      { amount: '1 oz', ingredient: 'SIMPS Chai', productId: 'chai' },
      { amount: '4 oz', ingredient: 'hot water' },
      { amount: '6 oz', ingredient: 'steamed milk' },
      { ingredient: 'cinnamon, to dust', optional: true }
    ],
    instructions: ['Combine both SIMPS syrups with the hot water.', 'Add steamed milk and stir.', 'Optionally dust with cinnamon.'],
    dashQuote: 'Chai plus brown sugar. Cozy has been achieved.',
    description: 'A spiced brown sugar chai latte.',
    labPackId: 'fall_lab', collection: 'fall_drink_menu', recipeSource: 'simps', testingStatus: 'approved'
  },
  {
    id: 'DL-077', name: 'Apple Butter Chai',
    drinkCompatibility: { coffee: 3 },
    heroProductId: 'spiced_apple',
    primaryProfiles: ['spiced', 'warm'], secondaryProfiles: ['cozy', 'sweet'],
    adventure: 'experiment', familiarity: 2, serve: ['hot'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'LOCAL Spiced Apple', productId: 'spiced_apple' },
      { amount: '1 oz', ingredient: 'SIMPS Brown Sugar Cinnamon', productId: 'brown_sugar_cinnamon' },
      { amount: '1 oz', ingredient: 'SIMPS Chai', productId: 'chai' },
      { amount: '6-8 oz', ingredient: 'steamed milk' },
      { ingredient: 'cinnamon', optional: true }
    ],
    instructions: ['Combine Spiced Apple, Brown Sugar Cinnamon, and Chai.', 'Add steamed milk and stir.', 'Optionally finish with cinnamon.'],
    dashQuote: 'Tastes like a hayride. In the best possible way.',
    description: 'A spiced apple butter chai built on LOCAL Spiced Apple.',
    labPackId: 'fall_lab', collection: 'fall_drink_menu', recipeSource: 'simps', testingStatus: 'approved'
  },
  {
    id: 'DL-078', name: 'Caramel Apple Matcha',
    drinkCompatibility: { coffee: 3 },
    heroProductId: 'spiced_apple',
    primaryProfiles: ['spiced', 'sweet'], secondaryProfiles: ['creamy', 'fresh'],
    adventure: 'experiment', familiarity: 3, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'LOCAL Spiced Apple', productId: 'spiced_apple' },
      { amount: '1 oz', ingredient: 'SIMPS Caramel', productId: 'caramel' },
      { amount: '1 tsp', ingredient: 'matcha' },
      { amount: '2 oz', ingredient: 'hot water' },
      { amount: '8 oz', ingredient: 'milk' },
      { ingredient: 'ice' }
    ],
    instructions: ['Whisk the matcha with the hot water.', 'Add Spiced Apple, Caramel, milk, and ice to a glass.', 'Pour the prepared matcha over top.'],
    dashQuote: 'Caramel apple, but make it green and slightly caffeinated.',
    description: 'An iced caramel apple matcha with a spiced apple base.',
    labPackId: 'fall_lab', collection: 'fall_drink_menu', recipeSource: 'simps', testingStatus: 'approved'
  },
  {
    id: 'DL-079', name: 'Maple Cinnamon Matcha',
    drinkCompatibility: { coffee: 3 },
    heroProductId: 'brown_sugar_cinnamon',
    primaryProfiles: ['spiced', 'fresh'], secondaryProfiles: ['sweet', 'cozy'],
    adventure: 'experiment', familiarity: 2, serve: ['either'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Brown Sugar Cinnamon', productId: 'brown_sugar_cinnamon' },
      { amount: '1/2 oz', ingredient: 'real maple syrup' },
      { amount: '1 tsp', ingredient: 'matcha' },
      { amount: '2 oz', ingredient: 'hot water' },
      { amount: '8 oz', ingredient: 'milk' }
    ],
    instructions: ['Whisk the matcha with the hot water.', 'Add maple syrup and Brown Sugar Cinnamon.', 'Add milk and the prepared matcha.', 'Serve hot or iced.'],
    dashQuote: 'Matcha met maple. They get along suspiciously well.',
    description: 'A maple cinnamon matcha, equally good hot or iced.',
    labPackId: 'fall_lab', collection: 'fall_drink_menu', recipeSource: 'simps', testingStatus: 'approved'
  },
  {
    id: 'DL-080', name: 'Toasted Coconut Chai',
    drinkCompatibility: { coffee: 3 },
    heroProductId: 'coconut',
    primaryProfiles: ['tropical', 'spiced'], secondaryProfiles: ['creamy', 'sweet'],
    adventure: 'experiment', familiarity: 2, serve: ['hot'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Coconut', productId: 'coconut' },
      { amount: '1 oz', ingredient: 'SIMPS Chai', productId: 'chai' },
      { amount: '8 oz', ingredient: 'steamed milk' },
      { ingredient: 'toasted coconut, to garnish', optional: true }
    ],
    instructions: ['Combine Coconut and Chai.', 'Add steamed milk and stir.', 'Optionally garnish with toasted coconut.'],
    dashQuote: 'Chai took a tropical vacation. Came back toasted.',
    description: 'A toasted coconut chai latte with a tropical lean.',
    labPackId: 'fall_lab', collection: 'fall_drink_menu', recipeSource: 'simps', testingStatus: 'approved'
  },
  {
    id: 'DL-081', name: 'Salted Honey Latte',
    drinkCompatibility: { coffee: 3 },
    heroProductId: 'salted_caramel',
    primaryProfiles: ['sweet', 'creamy'], secondaryProfiles: ['warm', 'dessert'],
    adventure: 'classic', familiarity: 1, serve: ['hot'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Salted Caramel', productId: 'salted_caramel' },
      { amount: '1/2 oz', ingredient: 'honey' },
      { amount: '2 shots', ingredient: 'espresso' },
      { amount: '8-10 oz', ingredient: 'steamed milk' },
      { ingredient: 'flaky salt, a tiny pinch', optional: true }
    ],
    instructions: ['Stir the honey and Salted Caramel into the espresso.', 'Add steamed milk.', 'Optionally finish with a tiny pinch of flaky salt.'],
    dashQuote: 'Sweet, salty, smooth. A balanced breakfast, arguably.',
    description: 'A salted honey latte with a salted caramel backbone.',
    labPackId: 'fall_lab', collection: 'fall_drink_menu', recipeSource: 'simps', testingStatus: 'approved'
  },
  {
    id: 'DL-082', name: 'Blackberry Vanilla London Fog',
    drinkCompatibility: { coffee: 3 },
    heroProductId: 'blackberry',
    primaryProfiles: ['berry', 'creamy'], secondaryProfiles: ['sweet', 'fruity'],
    adventure: 'classic', familiarity: 2, serve: ['hot'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Blackberry', productId: 'blackberry' },
      { amount: '1 oz', ingredient: 'SIMPS Vanilla', productId: 'vanilla' },
      { amount: '1', ingredient: 'Earl Grey tea bag' },
      { amount: '4 oz', ingredient: 'hot water' },
      { amount: '6 oz', ingredient: 'steamed milk' }
    ],
    instructions: ['Steep the Earl Grey tea for 4-5 minutes.', 'Remove the tea bag.', 'Stir in the Blackberry and Vanilla syrups.', 'Top with steamed milk.'],
    dashQuote: 'A London fog with a berry accent. Very sophisticated goose.',
    description: 'A blackberry vanilla London fog built on Earl Grey.',
    labPackId: 'fall_lab', collection: 'fall_drink_menu', recipeSource: 'simps', testingStatus: 'approved'
  },
  {
    id: 'DL-083', name: 'Banana Bread Latte',
    drinkCompatibility: { coffee: 3 },
    heroProductId: 'banana',
    primaryProfiles: ['sweet', 'dessert'], secondaryProfiles: ['cozy', 'warm'],
    adventure: 'experiment', familiarity: 2, serve: ['hot'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Banana', productId: 'banana' },
      { amount: '1/2 oz', ingredient: 'SIMPS Vanilla', productId: 'vanilla' },
      { amount: '1 oz', ingredient: 'SIMPS Brown Sugar Cinnamon', productId: 'brown_sugar_cinnamon' },
      { amount: '2 shots', ingredient: 'espresso' },
      { amount: '8 oz', ingredient: 'steamed milk' },
      { ingredient: 'cinnamon', optional: true }
    ],
    instructions: ['Stir all three SIMPS syrups into the espresso.', 'Add steamed milk.', 'Optionally finish with cinnamon.'],
    dashQuote: 'Banana bread you can drink. No baking, no supervision.',
    description: 'A banana bread latte with vanilla and brown sugar cinnamon.',
    labPackId: 'fall_lab', collection: 'fall_drink_menu', recipeSource: 'simps', testingStatus: 'approved'
  },
  {
    id: 'DL-084', name: 'Blueberry Muffin Latte',
    drinkCompatibility: { coffee: 3 },
    heroProductId: 'blueberry',
    primaryProfiles: ['berry', 'sweet'], secondaryProfiles: ['dessert', 'creamy'],
    adventure: 'classic', familiarity: 1, serve: ['hot'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Blueberry', productId: 'blueberry' },
      { amount: '1 oz', ingredient: 'SIMPS Vanilla', productId: 'vanilla' },
      { amount: '2 shots', ingredient: 'espresso' },
      { amount: '8-10 oz', ingredient: 'steamed milk' },
      { ingredient: 'vanilla cold foam', optional: true }
    ],
    instructions: ['Stir the Blueberry and Vanilla into the espresso.', 'Add steamed milk.', 'Optionally add vanilla cold foam for a bakery-style finish.'],
    dashQuote: 'Breakfast pastry, now legally a beverage.',
    description: 'A blueberry muffin latte with vanilla.',
    labPackId: 'fall_lab', collection: 'fall_drink_menu', recipeSource: 'simps', testingStatus: 'approved'
  },
  {
    id: 'DL-085', name: 'Caramel Prickly Pear Chai',
    drinkCompatibility: { coffee: 3 },
    heroProductId: 'prickly_pear',
    primaryProfiles: ['fruity', 'spiced'], secondaryProfiles: ['sweet', 'cozy'],
    adventure: 'goose', familiarity: 3, serve: ['hot'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Prickly Pear', productId: 'prickly_pear' },
      { amount: '1 oz', ingredient: 'SIMPS Caramel', productId: 'caramel' },
      { amount: '1 oz', ingredient: 'SIMPS Chai', productId: 'chai' },
      { amount: '6-8 oz', ingredient: 'steamed milk' },
      { ingredient: 'cinnamon or nutmeg', optional: true }
    ],
    instructions: ['Combine Prickly Pear, Caramel, and Chai.', 'Add steamed milk and stir.', 'Optionally finish with cinnamon or nutmeg.'],
    dashQuote: 'Prickly pear in a chai. The goose is experimenting again.',
    description: 'An adventurous caramel prickly pear chai latte.',
    labPackId: 'fall_lab', collection: 'fall_drink_menu', recipeSource: 'simps', testingStatus: 'approved'
  },
  {
    id: 'DL-086', name: 'Toasted Vanilla Dirty Chai',
    drinkCompatibility: { coffee: 3 },
    heroProductId: 'toasted_marshmallow',
    primaryProfiles: ['spiced', 'sweet'], secondaryProfiles: ['creamy', 'bold'],
    adventure: 'goose', familiarity: 3, serve: ['hot'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Toasted Marshmallow', productId: 'toasted_marshmallow' },
      { amount: '1 oz', ingredient: 'SIMPS Vanilla', productId: 'vanilla' },
      { amount: '1 oz', ingredient: 'SIMPS Chai', productId: 'chai' },
      { amount: '2 shots', ingredient: 'espresso' },
      { amount: '6-8 oz', ingredient: 'steamed milk' },
      { ingredient: 'cinnamon', optional: true }
    ],
    instructions: ['Combine Toasted Marshmallow, Vanilla, and Chai with the espresso.', 'Stir.', 'Add steamed milk.', 'Optionally finish with cinnamon.'],
    dashQuote: 'A dirty chai wearing a marshmallow disguise.',
    description: 'A toasted marshmallow dirty chai with vanilla.',
    labPackId: 'fall_lab', collection: 'fall_drink_menu', recipeSource: 'simps', testingStatus: 'approved'
  }
];